import React, { useState } from 'react';
import {
  doc, getDoc, getFirestore, collection, addDoc,
  serverTimestamp, query, where, getDocs
} from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { db, auth } from '../firebase';
import {
  getStorage, ref, uploadString
} from 'firebase/storage';
import BackHomeButton from '../components/BackHomeButton';

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Get_Help from '../components/Get_Help';
import Help_Video from '../components/Help_Video';

import { functions } from '../firebase'; // Ensure path is correct
import { httpsCallable } from 'firebase/functions';


function CompositionHelp() {
  const [subject, setSubject] = useState('');
  const [Question, setQuestion] = useState('');
  const [Answer, setAnswer] = useState('');
  const [aiResult, setAiResult] = useState('');
  const [message, setMessage] = useState('');
  const [standard, setStandard] = useState('unspecified');
  const [school, setSchool] = useState('unspecified');
  const [selectedLessonId, setSelectedLessonId] = useState('');
  const [trendingTopics, setTrendingTopics] = useState([]);
  const [language, setLanguage] = useState('');



  const [cooldown, setCooldown] = useState(0);
const [isCooldownActive, setIsCooldownActive] = useState(false);






  //const auth = getAuth();
  //const db = getFirestore();
  const storage = getStorage();
  const user = auth.currentUser;

  //alert(auth.currentUser);

  const location = useLocation();

  useEffect(() => {
  const fetchTrendingTopics = async () => {
    if (!school || !standard) return;

    try {
      const q = query(
        collection(db, 'ai_checked_answers'),
        where('user_school', '==', school),
        where('user_standard', '==', standard),
        where('Answer', 'in', ['hints', 'sentences'])
      );

      const snapshot = await getDocs(q);

      // Extract unique questions, latest first
      const questions = [];
      snapshot.docs
         .filter(doc => doc.data().subject === language)// 🔥 language filter here
        .sort((a, b) => b.data().timestamp?.seconds - a.data().timestamp?.seconds)
        .forEach(doc => {
          const qn = doc.data().Question;
          if (qn && !questions.includes(qn)) {
            questions.push(qn);
          }
        });

      setTrendingTopics(questions.slice(0, 10));
    } catch (err) {
      console.error('Error fetching trending topics:', err);
    }
  };

  fetchTrendingTopics();
}, [school, standard, db,language]);

  
async function fetchAIResponse(prompt) {

  const callGemini = httpsCallable(functions, 'callGemini');

  {/*
  // Old Try Gemini as fallback
  try {
    const geminiResponse = await fetch("https://us-central1-project-x-demo-6329b.cloudfunctions.net/callGemini", // replace with your key
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          contents: [{ parts: [{ text: prompt }] }]
        }),
      }
    );

    if (geminiResponse.ok) {
      const geminiData = await geminiResponse.json();
      //alert(geminiData);
      const content = geminiData.candidates?.[0]?.content?.parts?.[0]?.text;
      return content;
    } else {
      console.warn('Gemini failed:', await geminiResponse.text());
    }
  } catch (err) {
    console.error('Gemini error:', err);
  }

  */}

  // 2. Try Gemini as fallback
  try {
    const result = await callGemini({
      contents: [{ role: "user", parts: [{ text: prompt }] }],
      generationConfig: {
        maxOutputTokens: 8192,
        temperature: 0.7
      }
    });

    // 🛡️ Secure Note: The App Check token was sent automatically!
    // result.data contains the body of the response from your backend
    return result.data.candidates?.[0]?.content?.parts?.[0]?.text;

  } catch (err) {
    console.error('Gemini error:', err.message);
    
    // Check for specific security failures
    if (err.code === 'failed-precondition') {
      alert("Security Check Failed: Please refresh the page.");
    }
  }

  // If both fail
  alert("Oops All AI engines are busy for now .Please try in a couple of minutes.");
  return null;
}

  const [subjectList, setSubjectList] = useState([]);

  useEffect(() => {
    const fetchSubjects = async () => {
      try {
        if (!standard) return; // Don't fetch unless we have the user's standard

        const q = query(collection(db, 'Standard_Subject_Topic_Master'), where('Standard', '==', parseInt(standard)));
        const snapshot = await getDocs(q);
        const subjectsData = snapshot.docs.map(doc => doc.data().Subject);
        // Deduplicate and sort
        const uniqueSortedSubjects = [...new Set(subjectsData)].sort();

        setSubjectList(uniqueSortedSubjects);
      } catch (error) {
        console.error('Error fetching subjects:', error);
      }
    };

    fetchSubjects();
  }, [standard]);

// countdown effect
useEffect(() => {
  let timer;
  if (isCooldownActive && cooldown > 0) {
    timer = setInterval(() => {
      setCooldown(prev => prev - 1);
    }, 1000);
  } else if (cooldown === 0) {
    setIsCooldownActive(false);
  }
  return () => clearInterval(timer);
}, [cooldown, isCooldownActive]);
  
  useEffect(() => {
    const state = location.state;
    if (state) {
      if (state.subject) setSubject(state.subject);
    }
  }, [location.state]);

  useEffect(() => {
  const fetchProfile = async () => {
    if (!user) return;

    try {
      const profileRef = doc(db, 'profiles', user.uid);
      const profileSnap = await getDoc(profileRef);
      if (profileSnap.exists()) {
        const profileData = profileSnap.data();
        setStandard(profileData.standard || 'unspecified');
        setSchool(profileData.school || 'unspecified');
      }
    } catch (err) {
      console.error('Error fetching user profile:', err);
    }
  };

  fetchProfile();
}, [user,standard,db]);


  const handleGenerate = async () => {
    try {
      const profileRef = doc(db, 'profiles', user?.uid);
      const profileSnap = await getDoc(profileRef);
      if (profileSnap.exists()) {
        const profileData = profileSnap.data();
        setStandard(profileData.standard || 'unspecified');
      }
    } catch (err) {
      console.error('Error fetching user profile:', err);
    }

    //alert(language);
    //alert(Question);

    if (!language || !Question ) {

      alert('Please Provide Language and Topic');
      return;
    }

    let prompt = `You are a teacher of a student of standard ${standard}. 
    The student needs to be given ideas to frame 15 sentences on the topic ${Question}
    Give serial number in ideas please.
    Only Give ideas or suggestions do not give actual sentences.
    Do not give any suggestions or foul language in your response.\n`;

    if(language === "Hindi")
    {
    prompt += `give sentences in Devnagari script only`;
    }

    if(language === "English")
    {
    prompt += `give sentences in English only`;
    }

    if(language === "Telugu")
    {
    prompt += `give sentences in Telugu script only`;
    }

    if(language === "Tamil")
    {
    prompt += `give sentences in Tamil script only`;
    }

    if(language === "Kannada")
    {
    prompt += `give sentences in Kannada script only`;
    }

    setMessage(`Generating Ideas...`);    

    try {

      const content = await fetchAIResponse(prompt);

      if (!content) {
        alert('Failed to generate response from AI.');
        setMessage('AI did not return a response.');
        return;
      }

      setAiResult(content);

      const docRef = await addDoc(collection(db, 'ai_checked_answers'), {
        userId: user?.uid || 'anonymous',
        subject:language,
        Question,
        Answer:'hints',
        content,
        timestamp: serverTimestamp(),
        user_school: school,
        user_standard : standard
      });

      const storageRef = ref(storage, `ai_worksheets/${user?.uid}/${docRef.id}.txt`);
      await uploadString(storageRef, content);

      setMessage('Idea Generation successful!');

      setCooldown(600); // 10 minutes = 600 seconds
      setIsCooldownActive(true);
      
    } catch (err) {
      console.error(err);
      alert('Something went wrong: ' + err.message);
      setMessage('Failed to Check. Please try again.');
    }
  };

   const handleSentences = async () => {
    try {
      const profileRef = doc(db, 'profiles', user?.uid);
      const profileSnap = await getDoc(profileRef);
      if (profileSnap.exists()) {
        const profileData = profileSnap.data();
        setStandard(profileData.standard || 'unspecified');
      }
    } catch (err) {
      console.error('Error fetching user profile:', err);
    }

    if (!language  || !Question ) {
      alert('Please Provide Language and Topic');
      return;
    }

    let prompt = `You are a teacher of a student of standard ${standard}. 
    The student needs to be given an essay of 20-25 sentences on the topic ${Question}

    The sentences should be as per the student of standard ${standard}.

    You need to give the composition in a paragraph in the structure of Introduction to the topic,
    Actual content of the topic and then conclusion in that order always.Separated in paragraphs for 
    legibility.
    
    Only Give actual sentences. 
    Do not give any suggestions or foul language in your response.\n`;

    if(language === "Hindi")
    {
    prompt += `give sentences in Devnagari script only`;
    }

    if(language === "English")
    {
    prompt += `give sentences in English only`;
    }

    if(language === "Telugu")
    {
    prompt += `give sentences in Telugu script only`;
    }

    if(language === "Tamil")
    {
    prompt += `give sentences in Tamil script only`;
    }

    if(language === "Kannada")
    {
    prompt += `give sentences in Kannada script only`;
    }

    setMessage(`Generating Sentences...`);    

    try {

      const content = await fetchAIResponse(prompt);

      if (!content) {
        alert('Failed to generate response from AI.');
        setMessage('AI did not return a response.');
        return;
      }

      setAiResult(content);

      const docRef = await addDoc(collection(db, 'ai_checked_answers'), {
        userId: user?.uid || 'anonymous',
        subject:language,
        Question,
        Answer:'sentences',
        content,
        timestamp: serverTimestamp(),
        user_school: school,
        user_standard : standard
      });

      const storageRef = ref(storage, `ai_worksheets/${user?.uid}/${docRef.id}.txt`);
      await uploadString(storageRef, content);

      setMessage('Sentence Generation successful!');
      
    } catch (err) {
      console.error(err);
      alert('Something went wrong: ' + err.message);
      setMessage('Failed to Check. Please try again.');
    }
  };

return (
    <>
      {/* 🔹 Inject Keyframes for animations */}
      <style>{`
        @keyframes flame {
          0% { transform: scale(1) rotate(0deg); filter: brightness(1); }
          50% { transform: scale(1.2) rotate(2deg); filter: brightness(1.4); }
          100% { transform: scale(1) rotate(-2deg); filter: brightness(1); }
        }
        .flame { display: inline-block; animation: flame 1s infinite ease-in-out; }
        @keyframes scrollLeft {
          from { transform: translateX(0); }
          to { transform: translateX(-50%); }
        }
      `}</style>

      <div className="min-h-screen bg-[radial-gradient(ellipse_at_top_right,_var(--tw-gradient-stops))] from-indigo-50 via-slate-50 to-white py-2 sm:py-6 px-2 sm:px-6 lg:px-8 font-sans">
        
        {/* Full width container mirroring the Worksheet Generator */}
        <div className="w-full mx-auto bg-white/80 backdrop-blur-xl rounded-[1rem] sm:rounded-[2rem] shadow-2xl shadow-indigo-500/10 border border-white p-3 sm:p-8 relative overflow-hidden">
          
          {/* Top Nav & Header - All Inline */}
          <div className="flex items-center justify-between mb-2 sm:mb-4 w-full gap-2">
            <div className="flex-1 flex justify-start min-w-0">
              <BackHomeButton
                backState={{ selectedLessonId, subject }}
              />
            </div>
            <div className="flex-auto text-center px-1 sm:px-4 shrink-0">
              <h2 className="text-sm sm:text-2xl md:text-3xl font-extrabold text-slate-900 tracking-tight leading-tight whitespace-nowrap">
                Composition <span className="text-transparent bg-clip-text bg-gradient-to-r from-indigo-600 to-violet-600">Help</span>
              </h2>
            </div>
            {/* Empty div to perfectly balance the flex layout */}
            <div className="flex-1 flex justify-end min-w-0"><Get_Help/></div>
          </div>

          <div className="text-center mb-4 sm:mb-8">
            <p className="text-[10px] sm:text-sm text-slate-500 font-medium w-full mx-auto px-2">
              This tool will help you frame a composition on any topic as per your standard.
            </p>
          </div>

                    {/* Drop your reusable component here */}
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'start' }}>
            <Help_Video 
              videoId="fUGbIas_KVw" /* ⚠️ Replace with actual YouTube ID */
              title="How to use Voice to Text" 
            />
          </div>

                <br></br>

          {/* Trending Topics - Reduced mobile padding */}
          {trendingTopics.length > 0 && (
            <div className="mb-4 sm:mb-8 bg-slate-50 border border-slate-200 rounded-lg sm:rounded-xl p-2 sm:p-4 shadow-sm">
              <div className="flex items-center gap-2 mb-2 sm:mb-3 text-[9px] sm:text-xs font-bold text-slate-500 uppercase tracking-widest">
                <span className="flex h-1.5 w-1.5 sm:h-2 sm:w-2 rounded-full bg-orange-500 animate-pulse"></span>
                Recent topics in your school & standard
              </div>
              <div className="overflow-hidden w-full mask-linear-gradient">
                <div 
                  className="flex gap-2 w-max hover:[animation-play-state:paused]"
                  style={{ animation: 'scrollLeft 25s linear infinite' }}
                >
                  {[...trendingTopics, ...trendingTopics].map((topic, index) => (
                    <span
                      key={index}
                      className="bg-white border border-slate-200 hover:border-indigo-400 hover:text-indigo-600 transition-colors px-2 py-1 sm:px-4 sm:py-2 rounded-full text-[10px] sm:text-sm font-semibold text-slate-600 shadow-sm cursor-pointer whitespace-nowrap group"
                      onClick={() => setQuestion(topic)}
                    >
                      <span className="flame group-hover:scale-125 transition-transform">🔥</span> {topic}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* Form Configuration Grid */}
          <div className="space-y-3 sm:space-y-6 mb-4 sm:mb-8 max-w-4xl mx-auto">
            
            {/* Language Dropdown */}
            <div className="space-y-1 sm:space-y-2">
              <label className="block text-[11px] sm:text-sm font-bold text-slate-700 ml-1">Choose Language</label>
              <select
                value={language}
                onChange={(e) => setLanguage(e.target.value)}
                className="w-full bg-slate-50 border-2 border-slate-200 rounded-md sm:rounded-xl px-2 py-1.5 sm:px-3 sm:py-3 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/10 transition-all outline-none text-[11px] sm:text-base font-semibold text-slate-700 cursor-pointer appearance-none"
              >
                <option value="">Select Language</option>
                <option value="English">English</option>
                <option value="Hindi">Hindi</option>
                <option value="Tamil">Tamil</option>
                <option value="Telugu">Telugu</option>
                <option value="Kannada">Kannada</option>
              </select>
            </div>

            {/* Topic Input - Character count inside the box to save vertical height */}
            <div className="space-y-1 sm:space-y-2">
              <label className="block text-[11px] sm:text-sm font-bold text-slate-700 ml-1">Your Topic Please</label>
              <div className="relative">
                <textarea
                  className="w-full bg-slate-50 border-2 border-slate-200 rounded-md sm:rounded-xl p-2 sm:p-4 text-[11px] sm:text-sm focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/20 outline-none resize-y h-16 sm:h-28 custom-scrollbar pb-6"
                  value={Question}
                  onChange={e => {
                    if (e.target.value.length <= 50) setQuestion(e.target.value);
                  }}
                  placeholder="Type your topic here..."
                />
                <div className="absolute bottom-2 right-2 sm:bottom-3 sm:right-3 text-[9px] sm:text-xs font-bold text-slate-400">
                  {Question.length}/50
                </div>
              </div>
            </div>
          </div>

          {/* Generate Action */}
          <div className="max-w-4xl mx-auto">
            <button 
              onClick={handleGenerate} 
              className="w-full bg-slate-900 text-white p-2.5 sm:p-4 rounded-lg sm:rounded-2xl font-bold text-[11px] sm:text-base hover:bg-indigo-600 transition-all duration-300 shadow-lg hover:shadow-indigo-500/30 flex justify-center items-center gap-2"
            >
              ✨ Generate Ideas for my Topic
            </button>
            
            {/* Status Message */}
            {message && (
              <p className="text-center text-[10px] sm:text-sm font-bold text-indigo-500 animate-pulse mt-3 sm:mt-4">
                {message}
              </p>
            )}
          </div>

          {/* Preview & Sentences Action (Appears after generating ideas) */}
          {aiResult && (
            <div className="mt-4 sm:mt-10 pt-4 sm:pt-8 border-t border-slate-200 space-y-3 sm:space-5 animate-in fade-in slide-in-from-bottom-4 duration-500 max-w-4xl mx-auto">
              <div className="flex flex-row items-center justify-between">
                <label className="text-[13px] sm:text-lg font-bold text-slate-800">Preview Ideas</label>
              </div>
              
              <textarea 
                className="w-full bg-white text-slate-900 font-mono text-[10px] sm:text-sm leading-tight sm:leading-relaxed p-3 sm:p-5 rounded-lg sm:rounded-2xl border-2 border-slate-200 outline-none h-40 sm:h-80 resize-y focus:border-indigo-400 focus:ring-4 focus:ring-indigo-500/10 transition-all custom-scrollbar" 
                value={aiResult} 
                readOnly 
              />

              <button 
                onClick={handleSentences} 
                className="w-full bg-emerald-500 text-white p-2.5 sm:p-4 rounded-lg sm:rounded-2xl font-bold text-[11px] sm:text-base hover:bg-emerald-600 transition-all shadow-md sm:shadow-lg shadow-emerald-500/30 mt-2 sm:mt-4 flex justify-center items-center gap-2"
              >
                📝 I Need Actual Sentences Please
              </button>
            </div>
          )}

          <footer className="mt-6 sm:mt-14 text-center text-slate-400 text-[9px] sm:text-xs font-medium">
            © {new Date().getFullYear()} Eascode All Rights Reserved.
          </footer>
        </div>
      </div>
    </>
  );
}

export default CompositionHelp;
